export default {
    config: {
        apiKey: "AIzaSyAPWNyBvYs2yQPreq_UvEDdgxvXFNwvfpc",
        authDomain: "unkcrewdatabase.firebaseapp.com",
        projectId: "unkcrewdatabase",
        storageBucket: "unkcrewdatabase.appspot.com",
        messagingSenderId: "223692183168",
        appId: "1:223692183168:web:39d0326bb29fbcee147865"
    }
}